var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnergy = function SvgEnergy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "energy_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#energy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11 14.5-5.925-.75c-.417-.05-.688-.275-.813-.675s-.037-.742.263-1.025l10.225-9.8a.797.797 0 0 1 .3-.188c.117-.041.275-.062.475-.062.333 0 .588.142.763.425.174.283.179.575.012.875L13 9.5l5.925.75c.417.05.688.275.813.675s.037.742-.263 1.025L9.25 21.75a.798.798 0 0 1-.3.188 1.454 1.454 0 0 1-.475.062.844.844 0 0 1-.763-.425c-.175-.283-.179-.575-.012-.875l3.3-6.2Z",
    fill: "#1C1B1F"
  }))));
};
export default SvgEnergy;